import _ from "lodash"
import defaultMessages from "../../i18n/default.messages"

let messages = {
    messages: {
        'es-MX': {
            moduleTitle: 'Mapas',
            tblTitle: 'Listado de mapas',
            tblbutton: 'Nuevo Mapa',
            mdlSave: 'Guardar',
            mdlCancel: 'Cancelar',


            lblMapName: 'Nombre del mapa',
            lblMapDescription: 'Descripción',

            headerName: "Nombre del mapa",
            headerDescription: "Descripción",
            headerLocation: "Ubicación",
            headerStatus: "ESTADO",
            headerAction: "ACCIONES",
            headerSearch: 'Buscar',

            btnCancel: "CANCELAR",
            btnOk: "ACEPTAR",
            btnUpdateMap: "ACTUALIZAR",

            dlgEditMapTitle: "Actualizar datos del mapa",

            dlgNewMapTitle: "Nuevo mapa",
            btnNewMap: "CREAR MAPA",
            lblFileName: 'Seleccione un archivo PDF',
            lblLocation: 'Seleccione una ubicaión',
            lblFileTypeError: "Formato de archivo no permitido. Por favor seleccione un archivo PDF.",

            dlgDeleteMapTitle: "Eliminar mapa",
            dlgDeleteText: "¿Está seguro de eliminar el mapa <code>{mapName}</code>?",
            btnDeleteMap: "ELIMINAR",

            dlgMapTitle: "Mapa",

        },
        en: {
            moduleTitle: 'Maps',
            tblTitle: 'Maps List',
            tblbutton: 'New Maps',
            mdlSave: 'Save',
            mdlCancel: 'Cancel',


            lblMapName: 'Map name',
            lblFileName: 'File name',
            lblLocation: 'Select a location',
            lblMapDescription: 'Select a PDF file',

            headerName: "Map name",
            headerDescription: "Description",
            headerLocation: "Ubicación",
            headerStatus: "STATUS",
            headerAction: "ACTIONS",
            headerSearch: 'Search',

            btnCancel: "CANCEL",
            btnOk: "DONE",
            btnUpdateMap: "UPDATE",

            dlgEditMapTitle: "Edit map",

            dlgNewMapTitle: "New map",
            btnNewMap: "ADD MAP",
            lblFileTypeError: "File format is hot allowed. Please select a PDF file.",

            dlgDeleteMapTitle: "Delete map",
            dlgDeleteText: "You are about to delete <code>{mapName}</code> map, are you agree to proceed?",
            btnDeleteMap: "DELETE",

            dlgMapTitle: "Map",

        }
    }
}

export default _.merge(messages, defaultMessages)